import { baseDatasetViewConfiguration } from "types/schemas/dataset_view_configuration.schema";
import { UnitLong } from "viewer/constants";

export default {
  $schema: "http://json-schema.org/draft-06/schema#",
  ...baseDatasetViewConfiguration,
  definitions: {
    "types::Vector2": {
      type: "array",
      items: {
        type: "number",
      },
      minItems: 2,
      maxItems: 2,
    },
    "types::Vector3": {
      type: "array",
      items: {
        type: "number",
      },
      minItems: 3,
      maxItems: 3,
    },
    "types::Vector4": {
      type: "array",
      items: {
        type: "number",
      },
      minItems: 4,
      maxItems: 4,
    },
    "types::BoundingBox": {
      type: "object",
      properties: {
        topLeft: {
          $ref: "#/definitions/types::Vector3",
        },
        width: {
          type: "number",
        },
        height: {
          type: "number",
        },
        depth: {
          type: "number",
        },
      },
      required: ["topLeft", "width", "height", "depth"],
    },
    "types::DataLayerWKWPartial": {
      title: "DataLayerWKW",
      type: "object",
      properties: {
        dataFormat: {
          const: "wkw",
        },
        boundingBox: {
          $ref: "#/definitions/types::BoundingBox",
        },
        mags: {
          type: "array",
          items: {
            type: "object",
            properties: {
              mag: {
                anyOf: [
                  {
                    type: "number",
                  },
                  {
                    $ref: "#/definitions/types::Vector3",
                  },
                ],
              },
              path: {
                type: "string",
              },
              credentials: {
                type: "object",
                properties: {
                  user: { type: "string" },
                  password: { type: "string" },
                },
                required: ["user", "password"],
              },
              axisOrder: {
                type: "object",
                additionalProperties: { type: "number" },
              },
            },
            required: ["mag"],
          },
        },
      },
      required: ["dataFormat", "mags"],
    },
    "types::DataLayerZarrPartial": {
      title: "DataLayerZarr",
      type: "object",
      properties: {
        dataFormat: {
          const: "zarr",
        },
        boundingBox: {
          $ref: "#/definitions/types::BoundingBox",
        },
        numChannels: {
          type: "number",
        },
        additionalAxes: {
          type: "array",
          items: {
            type: "object",
            properties: {
              name: {
                type: "string",
              },
              bounds: {
                $ref: "#/definitions/types::Vector2",
              },
              index: {
                type: "number",
              },
            },
          },
        },
        mags: {
          type: "array",
          items: {
            type: "object",
            properties: {
              mag: {
                anyOf: [
                  {
                    type: "number",
                  },
                  {
                    $ref: "#/definitions/types::Vector3",
                  },
                ],
              },
              path: {
                type: "string",
              },
              credentials: {
                type: "object",
                properties: {
                  user: { type: "string" },
                  password: { type: "string" },
                },
                required: ["user", "password"],
              },
              axisOrder: {
                type: "object",
                additionalProperties: { type: "number" },
              },
            },
            required: ["mag"],
          },
        },
      },
      required: ["dataFormat", "mags"],
    },
    "types::DataLayerN5Partial": {
      title: "DataLayerN5",
      type: "object",
      properties: {
        dataFormat: {
          const: "n5",
        },
        boundingBox: {
          $ref: "#/definitions/types::BoundingBox",
        },
        numChannels: {
          type: "number",
        },
        mags: {
          type: "array",
          items: {
            type: "object",
            properties: {
              mag: {
                anyOf: [
                  {
                    type: "number",
                  },
                  {
                    $ref: "#/definitions/types::Vector3",
                  },
                ],
              },
              path: {
                type: "string",
              },
              credentials: {
                type: "object",
                properties: {
                  user: { type: "string" },
                  password: { type: "string" },
                },
                required: ["user", "password"],
              },
              axisOrder: {
                type: "object",
                additionalProperties: { type: "number" },
              },
            },
            required: ["mag"],
          },
        },
      },
      required: ["dataFormat", "mags"],
    },
    "types::DataLayerPrecomputedPartial": {
      title: "DataLayerPrecomputed",
      type: "object",
      properties: {
        dataFormat: {
          const: "neuroglancerPrecomputed",
        },
        boundingBox: {
          $ref: "#/definitions/types::BoundingBox",
        },
        numChannels: {
          type: "number",
        },
        mags: {
          type: "array",
          items: {
            type: "object",
            properties: {
              mag: {
                anyOf: [
                  {
                    type: "number",
                  },
                  {
                    $ref: "#/definitions/types::Vector3",
                  },
                ],
              },
              path: {
                type: "string",
              },
              credentials: {
                type: "object",
                properties: {
                  user: { type: "string" },
                  password: { type: "string" },
                },
                required: ["user", "password"],
              },
              axisOrder: {
                type: "object",
                additionalProperties: { type: "number" },
              },
            },
            required: ["mag"],
          },
        },
      },
      required: ["dataFormat", "mags"],
    },
    "types::DataLayerZarr3Partial": {
      title: "DataLayerZarr3",
      type: "object",
      properties: {
        dataFormat: {
          const: "zarr3",
        },
        boundingBox: {
          $ref: "#/definitions/types::BoundingBox",
        },
        numChannels: {
          type: "number",
        },
        mags: {
          type: "array",
          items: {
            type: "object",
            properties: {
              mag: {
                anyOf: [
                  {
                    type: "number",
                  },
                  {
                    $ref: "#/definitions/types::Vector3",
                  },
                ],
              },
              path: {
                type: "string",
              },
              credentials: {
                type: "object",
                properties: {
                  user: { type: "string" },
                  password: { type: "string" },
                },
                required: ["user", "password"],
              },
              axisOrder: {
                type: "object",
                additionalProperties: { type: "number" },
              },
            },
            required: ["mag"],
          },
        },
      },
      required: ["dataFormat", "mags"],
    },
    "types::DataLayer": {
      title: "DataLayer",
      allOf: [
        {
          title: "DataLayerBasic",
          type: "object",
          properties: {
            name: {
              type: "string",
            },
            category: {
              enum: ["color", "segmentation"],
            },
            elementClass: {
              enum: [
                "uint8",
                "uint16",
                "uint24",
                "uint32",
                "uint64",
                "float",
                "double",
                "int8",
                "int16",
                "int32",
                "int64",
              ],
            },
            defaultViewConfiguration: {
              $ref: "#/definitions/types::OptionalLayerViewConfiguration",
            },
          },
          required: ["name", "category", "elementClass"],
        },
        {
          title: "DataLayerCategories",
          anyOf: [
            {
              title: "DataLayerColor",
              type: "object",
              properties: {
                category: {
                  const: "color",
                },
              },
              required: ["category"],
            },
            {
              title: "DataLayerSegmentation",
              type: "object",
              properties: {
                category: {
                  const: "segmentation",
                },
                largestSegmentId: {
                  // Unsigned-decimal string (see datasource.types.ts): uint64 ids can exceed the
                  // JS safe-integer range, and jsonschema validates JSON.parse output which never
                  // yields a bigint. The pattern preserves the former `minimum: 1` intent
                  // (a positive integer, no leading zeros).
                  type: ["string", "null"],
                  pattern: "^[1-9][0-9]*$",
                },
                mappings: {
                  type: "array",
                  items: {
                    type: "string",
                  },
                },
              },
              required: ["category"],
            },
          ],
        },
        {
          title: "DataLayerFormats",
          anyOf: [
            {
              $ref: "#/definitions/types::DataLayerWKWPartial",
            },
            {
              $ref: "#/definitions/types::DataLayerZarrPartial",
            },
            {
              $ref: "#/definitions/types::DataLayerN5Partial",
            },
            {
              $ref: "#/definitions/types::DataLayerPrecomputedPartial",
            },
            {
              $ref: "#/definitions/types::DataLayerZarr3Partial",
            },
          ],
        },
      ],
    },
    "types::DatasourceConfiguration": {
      type: "object",
      properties: {
        id: {
          type: "object",
          properties: {
            name: {
              type: "string",
            },
            team: {
              type: "string",
            },
          },
          additionalProperties: false,
          required: ["name", "team"],
        },
        dataLayers: {
          type: "array",
          minItems: 1,
          items: {
            $ref: "#/definitions/types::DataLayer",
          },
        },
        scale: {
          type: "object",
          properties: {
            factor: {
              type: "array",
              items: {
                type: "number",
                exclusiveMinimum: 0,
              },
              minItems: 3,
              maxItems: 3,
            },
            unit: {
              enum: Object.values(UnitLong),
            },
          },
        },
        defaultViewConfiguration: {
          $ref: "#/definitions/types::OptionalDatasetViewConfiguration",
        },
      },
      required: ["id", "dataLayers", "scale"],
    },
    "types::CoordinateTransformations": {
      items: {
        anyOf: [
          {
            properties: {
              matrix: {
                items: {
                  $ref: "#/definitions/types::Vector4",
                },
                maxItems: 4,
                minItems: 4,
                type: "array",
              },
              type: {
                const: "affine",
                type: "string",
              },
            },
            type: "object",
            required: ["type", "matrix"],
          },
          {
            properties: {
              correspondences: {
                properties: {
                  source: {
                    items: {
                      $ref: "#/definitions/types::Vector3",
                    },
                    type: "array",
                  },
                  target: {
                    items: {
                      $ref: "#/definitions/types::Vector3",
                    },
                    type: "array",
                  },
                },
                type: "object",
                required: ["source", "target"],
              },
              type: {
                const: "thin_plate_spline",
                type: "string",
              },
            },
            type: "object",
            required: ["type", "correspondences"],
          },
        ],
      },
      type: "array",
    },
    "types::DataLayerWithTransformations": {
      type: "array",
      items: {
        type: "object",
        properties: {
          name: {
            type: "string",
          },
          coordinateTransformations: {
            $ref: "#/definitions/types::CoordinateTransformations",
          },
        },
        required: ["name"],
      },
    },
  },
};
